import jwt from "jsonwebtoken";
import {api} from "@/common/api";
import {useCookies} from 'vue3-cookies'
import {CONFIG} from "@/common/config";

const cookies = useCookies()

export const auth = {
    isAuthorized: () => {
        let token = cookies.cookies.get('Token')

        if (token === 'null' || !token) {
            return false
        }

        const payload = jwt.verify(token, CONFIG.PUBLIC_KEY, {
            ignoreExpiration: true
        })
        return payload.exp * 1000 > Math.floor(Date.now())
    },
    getToken: () => {
        let token = cookies.cookies.get('Token')
        if (!auth.isAuthorized()) {
            return null
        }

        return token
    },
    getUsername: () => {
        const token = auth.getToken()
        if (token === 'null' || !token) {
            return null
        }

        const payload = jwt.verify(token, CONFIG.PUBLIC_KEY, {
            ignoreExpiration: true
        })
        return payload.username
    },
    getRoles: () => {
        const token = auth.getToken()
        if (token === 'null' || !token) {
            return []
        }

        const payload = jwt.verify(token, CONFIG.PUBLIC_KEY, {
            ignoreExpiration: true
        })
        return payload.roles
    },
    issueToken: (username, password, callback) => {
        api.issueToken(username, password, (response) => {
            if (response?.data?.token !== undefined) {
                let expireDate = new Date();
                expireDate.setTime(expireDate.getTime() + 24 * 60 * 60 * 1000);
                cookies.cookies.set('Token', response.data.token, expireDate)
                callback(true)
            } else {
                callback(false)
            }
        })
    },
    register: (username, password, callback) => {
        api.createUser(username, password, callback)
    },
    confirmUser(id, hash, callback) {
        api.updateRegisterSubmission(id, hash, callback)
    },
    sendForgotMail: (email, callback) => {
        api.createForgotLink(email, callback)
    },
    resetPassword: (id, password, token, callback) => {
        api.updateForgotLink(id, password, token, callback)
    },
    signOut: () => {
        cookies.cookies.remove('Token')
    }
}